import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppIcons from '../../utils/image';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/hooks/useAuth';

const Login = () => {
  const { signInWithGoogle, user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoogleLogin = useCallback(() => {
    signInWithGoogle();
  }, []);

  //console.log('login--', user);

  useEffect(() => {
    if (user) {
      //localStorage.getItem('lastVisitedPath') || '/home/transactions'
      let path = localStorage.getItem('lastVisitedPath');
      if (user && user.dash && user.dash.activeType === 'NMS') {
        path = '/home/NMS-Alert-Zendesk';
      } else {
        path = '/home/transactions';
      }
      // let lastMenu = localStorage.getItem('selectedMenu');

      navigate(path);
    }
  }, [user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md bg-white shadow-md rounded-lg p-8">
        <div className="flex justify-center items-center gap-4 mb-6">
          <img
            src={AppIcons.logoSymbol}
            alt="logoSymbol"
            className="w-10 h-auto"
          />
          <img src={AppIcons.logoText} alt="logoText" className="w-60 h-auto" />
        </div>

        <h2 className="text-center text-2xl font-extrabold text-gray-900 mb-6">
          {t('login.signIn')}
        </h2>

        <button
          onClick={handleGoogleLogin}
          className="flex items-center justify-start w-full bg-blue-600 text-white font-semibold py-1 px-1 rounded-lg focus:outline-none focus:shadow-outline mb-6 hover:bg-blue-700"
        >
          <img
            src={AppIcons.googleLogo}
            alt="Google"
            className="h-14 w-14 mr-14 ml-0"
          />
          {t('login.signInWithGoogle')}
        </button>

        <div className="text-center text-gray-500 mb-4">{t('login.or')}</div>

        <form className="space-y-6">
          {/* Email input */}
          <div>
            <label
              htmlFor="email"
              className="block text-gray-700 text-sm font-medium"
            >
              {t('login.emailLabel')}
            </label>
            <input
              id="email"
              type="email"
              placeholder={t('login.emailPlaceholder')}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Password input */}
          <div>
            <label
              htmlFor="password"
              className="block text-gray-700 text-sm font-medium"
            >
              {t('login.passwordLabel')}
            </label>
            <div className="relative">
              <input
                id="password"
                type="password"
                placeholder={t('login.passwordPlaceholder')}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <span className="absolute inset-y-0 right-3 flex items-center cursor-pointer">
                <svg
                  className="h-5 w-5 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 12H3M12 15l3-3-3-3"
                  />
                </svg>
              </span>
            </div>
          </div>

          {/* Forgot password link */}
          <div className="text-right">
            <a href="#" className="text-sm text-blue-600 hover:underline">
              {t('login.forgotPassword')}
            </a>
          </div>

          {/* Submit button */}
          <div>
            <button className="w-full bg-orange-500 text-white font-semibold py-3 px-4 rounded-lg hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-600">
              {t('login.signInButton')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
